import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/api';

@Component({
  selector: 'app-otppopup',
  templateUrl: './otppopup.component.html',
  styleUrls: ['./otppopup.component.css']
})
export class OtppopupComponent implements OnInit {
  temp: any;
  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }

  ngOnInit() {
    this.temp = this.config.data;
  }

  onOTPSuccess() {
    this.ref.close(true);
  }

}
